import classNames from "classnames"

type BoxWrapperProps = {
    children: React.ReactNode,
    className?:string,
}
export const BoxWrapper = ({children, className}:BoxWrapperProps) =>{
    return(
        <div
            className={classNames(
                "rounded-2xl p-5 md:p-6 w-full h-full min-h-[180px] border border-white/60 dark:border-white/10 backdrop-blur-xl shadow-sm flex items-start gap-3 transition-all duration-300 hover:shadow-md relative overflow-hidden",
                className,
            )}
        >
            {children}
        </div>
    )
}
